import React from 'react';
import { ShieldX, LogOut } from 'lucide-react';
import { isEntraAuth, msalInstance } from '../auth/authConfig';

const AccessDeniedPage = () => {
  const handleSignOut = () => {
    if (isEntraAuth() && msalInstance) {
      msalInstance.logoutRedirect();
    }
  };

  return (
    <div style={{
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      minHeight: '100vh',
      background: 'var(--color-bg-page, #f5f5f5)',
      padding: '2rem'
    }}>
      <div style={{
        background: 'white',
        borderRadius: '8px',
        padding: '3rem',
        maxWidth: '480px',
        width: '100%',
        textAlign: 'center',
        boxShadow: '0 2px 8px rgba(0,0,0,0.1)'
      }}>
        <ShieldX size={64} style={{ color: 'var(--color-danger, #dc2626)', marginBottom: '1.5rem' }} />
        <h1 style={{ fontSize: '1.5rem', fontWeight: 600, marginBottom: '0.75rem', color: 'var(--color-text-primary, #1e293b)' }}>
          Access Denied
        </h1>
        <p style={{ color: 'var(--color-text-secondary, #64748b)', lineHeight: 1.6, marginBottom: '2rem' }}>
          You've authenticated successfully, but you don't have an account in Dawn.
          Contact an administrator to request access.
        </p>
        <button
          onClick={handleSignOut}
          style={{
            display: 'inline-flex',
            alignItems: 'center',
            gap: '0.5rem',
            padding: '0.625rem 1.25rem',
            background: 'var(--color-primary, #2563eb)',
            color: 'white',
            border: 'none',
            borderRadius: '6px',
            fontSize: '0.875rem',
            fontWeight: 500,
            cursor: 'pointer'
          }}
        >
          <LogOut size={16} />
          Sign Out
        </button>
      </div>
    </div>
  );
};

export default AccessDeniedPage;
